import React from 'react'
import styled from 'styled-components'
import { SCARLET_THEME } from '@constants/theme-prefs'

// in the future, might want to be able to swap between "site default" theme and "custom page" themes
const { backgroundImage, textColor, contentBgColor } = SCARLET_THEME

const BackgroundContainer = styled.div`
    background-image: url("${backgroundImage}");
    display: flex;
    justify-content: center;
    height: 100%;
    flex: 1 0 100vh;
`

const ContentContainer = styled.div`
    width: 80%;
    max-width: 810px;
    background-color: ${contentBgColor};
    color: ${textColor};
`

export default function PageContainer ({ children }: {
    children: React.ReactNode;
    // backgroundImage?: string;
}) {
    return (
        <BackgroundContainer>
            <ContentContainer>
                {children}
            </ContentContainer>
        </BackgroundContainer>
    )
}